import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface OpportunityApplicationState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allOpportunityApplication: [] | null | any;
  projectPhaseActivities: any | null;
}

const initialState: OpportunityApplicationState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allOpportunityApplication: null,
  projectPhaseActivities: null,
};

export const opportunityApplicationSlice = createSlice({
  name: 'OpportunityApplication',
  initialState,
  reducers: {
    setAllOpportunityApplication: (state, action) => {
      state.allOpportunityApplication = action.payload.data;
    },
    setOpportunityApplication: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllOpportunityApplicationBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setProjectPhaseActivities: (state, action) => {
      state.projectPhaseActivities = action.payload.data;
    },
    reset: () => initialState,
  },
});

export const {
  setAllOpportunityApplication,
  setOpportunityApplication,
  setAllOpportunityApplicationBySearch,
  reset,
} = opportunityApplicationSlice.actions;

// Selectors
export const allOpportunityApplicationDetails = (state: RootState) =>
  state.opportunityApplication.allOpportunityApplication;

export const getOpportunityApplicationDetails = (state: RootState) =>
  state.opportunityApplication.data;

export const getOpportunityApplicationTotalRecords = (state: RootState) =>
  state.opportunityApplication.totalRecords;

export const getAllOpportunityApplicationBySearch = (state: RootState) =>
  state.opportunityApplication.data;

export default opportunityApplicationSlice.reducer;
